import type { Login } from './login.type.ts';
export interface LoginExtension extends Login {}
export class LoginExtension {
  /*************************
   * Computed Properties  *
   *************************/
  get isEditable() {
    return this.provider === 'EMAIL';
  }
}

const Registration = {
  kind: 'object',
  name: 'login',
  features: LoginExtension,
};
export default Registration;
